export const GUILD_NETWORK_ID = 2
export const FC_NETWORK_ID = 7
export const FC_INTL_NETWORK_ID = 8

export const LEADPRO_ASSOCIATE_ID = 2666
export const APS_PROPENSITY_TO_MOVE = 38
